import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import VisitorCountryRedirect from './tailwind/visitor-country-redirect';
// Micro Modal
import MicroModal from './tailwind/MicroModal';
// Tailwind UI Elements
import {Collapse, initTE,} from "tw-elements";
// Table Respsonsive
import TableResponsive from './services/table_responsive/TableResponsive';
// Collapsible
import CollapsibleButton from '@RESOURCES/js/services/collapsible/CollapsibleButton';
import Collapsible from '@RESOURCES/js/services/collapsible/Collapsible';

Alpine.plugin(collapse);
window.Alpine = Alpine;

Alpine.start();

// app js classes / validation
function init() {
    new VisitorCountryRedirect();
}

init();

window.MicroModal = MicroModal;

initTE({Collapse});

new TableResponsive().init();

global.CollapsibleButton = CollapsibleButton;
global.Collapsible = Collapsible;
